<template>
    <div>
        <ul class="m-0 p-0">
            <div
                :class="{
                    'mb-3': isFilteredShops('N') && isFilteredShops('Y')
                }"
            >
                <li v-for="(option, id) in getFilteredShops('Y')" :key="id">
                    {{ `${option.shopName}, ${option.shopAddress}` }}
                </li>
            </div>
            <div v-if="isFilteredShops('N')" class="typo--gray">
                <span class="info-value">Nieaktywne sklepy:</span>
                <li v-for="(option, id) in getFilteredShops('N')" :key="id">
                    {{ `${option.shopName}, ${option.shopAddress}` }}
                </li>
            </div>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'StoreUserShops',
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    methods: {
        getFilteredShops(status) {
            return this.data.filter(el => el.status === status)
        },
        isFilteredShops(status) {
            return this.getFilteredShops(status).length
        }
    }
}
</script>
